import React, { useState, useEffect } from 'react';
import { subscriptionService } from '../api/services';
import './FollowButton.css';

// 追蹤按鈕：訂閱/取消訂閱某個頻道或標籤。
// subscribed 由父層依「我的訂閱清單」傳入初始狀態，避免每顆按鈕各自打 API；點擊後就地切換並回呼父層。
const FollowButton = ({ targetType, targetId, subscribed = false, onChange, size }) => {
  const [isSub, setIsSub] = useState(subscribed);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setIsSub(subscribed); }, [subscribed]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      if (isSub) {
        await subscriptionService.unsubscribe(targetType, targetId);
      } else {
        await subscriptionService.subscribe(targetType, targetId);
      }
      const next = !isSub;
      setIsSub(next);
      if (onChange) onChange(next);
    } catch {
      /* 靜默失敗，不阻斷瀏覽 */
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      className={`follow-btn ${isSub ? 'following' : ''} ${size === 'sm' ? 'sm' : ''}`}
      onClick={toggle}
      disabled={busy}
      title={isSub ? '取消追蹤' : '追蹤此領域，有新文章時通知你'}
    >
      {isSub ? '✓ 追蹤中' : '+ 追蹤'}
    </button>
  );
};

export default FollowButton;
